import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Store } from '../index';
import { LandingPage } from './Landing';
import { PreConference } from './PreConference';
import { CancellationOrRefund } from './CancellationOrRefund';
import { EventPaymentPage } from './EventPaymentPage';
import { Venue } from './Venue';
import { PostConferenceTour } from './PostConferenceTour';
import { Accommodation } from './Accommodation';
import { ContactUs } from './ContactUs';
import { AdminPage } from './Admin';
import { types } from 'mobx-state-tree';
import { ToggleModel } from '../../../utils/pageUtils';
import { Dialog } from '@blueprintjs/core/dist';
/*import Form from '../../../components/form';*/
import { EntityModel } from '../../../utils/stores';
import { Sponsor } from './Sponsor';
import { EventsWorkshop } from './EventsWorkshop';

import '../resources/custom.css';
import '../resources/color.css';
import '../resources/font.css';
import { RegistrationForm } from "./parts/Registration";

const bannerImage = require('../resources/bannerImage.png');
const bcomsLogo = require('../resources/bcoms_logo.png');

const UserLogin = types.model('UserLogin', {
  userName: types.optional(types.string, ''),
  password: types.optional(types.string, ''),

  get formFields() {
    return {
      fields: [
        {
          label: 'person',
          name: 'userName',
          placeholder: 'username',
          rules: 'required',
          type: 'text',
          extra: {
            iconName: 'person'
          }
        },
        {
          label: 'lock',
          name: 'password',
          placeholder: 'password',
          rules: 'required',
          type: 'password',
          extra: {
            iconName: 'lock'
          }
        },
      ]
    };
  }
});

const Link = inject('store')(observer((props: {
  store?: typeof Store.Type;
  className?: string;
  text: string;
  viewName: string;
  registrationToggle: typeof ToggleModel.Type;
}) => (

      <a
        className={props.className ||
          'link white b f6 dib ph3 pv2 hover-bg-lightest-blue dib'}
        onClick={e => {
          e.preventDefault();
          props.store!.app.view.currentView.changeView(props.viewName);
        }}
      >
      {props.text}
      </a>

  )));

const Navbar = inject('store')(observer((props: {
  store?: typeof Store.Type;
  loginToggle: typeof ToggleModel.Type,
  registrationToggle: typeof ToggleModel.Type,
  // tslint:disable-next-line:no-any
  userLoginStore: any,
  viewName: string
}) => (
  <div>
    <div className="db dtc-l fl w-100 bg_banner sans-serif">
      <img src={bannerImage} alt="Event photo" className="w-100 dn-l" />
      <div className="center dn db-l">
        <div className="dt pv3 center">
          <div className="dtc v-mid w-40 w-40-ns pa2">
            <p className="tc mb0"><img src={bcomsLogo} alt="Event photo" className="w-80" /></p>
          </div>
          <div className="dtc w-60 w-60-ns pa2 pb0 moon-gray">
            <p className="b f3 lh-solid mb4">
            <span className="banner_orange_color f1">5 <sup className="banner_superscript">th</sup></span> National 
            <span className="banner_orange_color f1 pl4">2 <sup className="banner_superscript">nd</sup></span>
             International <br/> Bangladesh Conference on Oral {'&'} Maxillofacial Surgery</p>
            <div className=" center">
              <div className="cf lh-solid">
                <div className="fl w-100">
                  <div className="fl w-10 pa2 pl0 pb0">
                    <p className="red f4 mb0 banner_orange_color">Date: </p>
                  </div>
                  <div className="fl w-90 pa2 pb0">
                    <p className="f4 mb0">20th January 2018</p>
                  </div>
                </div>
                <div className="fl w-100">
                  <div className="fl w-10 pa2 pl0 pb0">
                    <p className="red f4 mb0 banner_orange_color">Venue: </p>
                  </div>
                  <div className="fl w-90 pa2 pb0">
                    <p className="f4 mb0">Bangabandhu International Conference Center (BICC)</p>
                  </div>
                </div>
                <div className="fl w-100">
                  <div className="fl w-10 pa2 pl0">
                    <p className="red f4 banner_orange_color">Time: </p>
                  </div>
                  <div className="fl w-90 pa2 pb0">
                    <p className="f4"> 8:00 AM - 8:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav className="db w-100 border-box bb pb0 overflow-x-auto bg-navbar">
      <div className="db w-100 v-mid tc nowrap navbar-menu">
        <Link text="HOME" viewName="landing" registrationToggle={props.registrationToggle} />
        <Link text="PRE-CONFERENCE" viewName="preConference" registrationToggle={props.registrationToggle} />
        {/* <a
          className="link white b f6 dib ph3 pv2 hover-bg-lightest-blue"
          onClick={e => {
            e.preventDefault();
            props.registrationToggle.toggle();
          }}
        >REGISTRATION
        </a> */}
        <Link text="CANCELLATION / REFUND" viewName="cancellationOrRefund" registrationToggle={props.registrationToggle} />
        <Link text={'VENUE'} viewName="venue" registrationToggle={props.registrationToggle} />
        <Link text="POST-CONFERENCE TOURS" viewName="postConferenceTour" registrationToggle={props.registrationToggle} />
        {/* <Link text="ACCOMODATION" viewName="accommodation" registrationToggle={props.registrationToggle} /> */}
        <Link text="EVENTS & WORKSHOP" viewName="eventsWorkshop" registrationToggle={props.registrationToggle} />
        <Link text="CONTACT US" viewName="contactUs" registrationToggle={props.registrationToggle} />
        <Link text="SPONSORS" viewName="sponsor" registrationToggle={props.registrationToggle} />
        {/*<a
          onClick={e => {
            e.preventDefault();
            props.loginToggle.toggle();
          }}
          className="f6 dib white b bg-animate hover-bg-blue no-underline pv2 mr2 ph4 br-pill ba b--white-20 hover-white mb2"
        >Sign in
        </a>*/}
      </div>
      <Dialog
        title="Registration"
        iconName="person"
        isCloseButtonShown={true}
        canEscapeKeyClose={true}
        isOpen={props.registrationToggle.value}
        onClose={props.registrationToggle.toggle}
        className="w-100 w-50-ns"
      >
        <RegistrationForm registrationToggle={props.registrationToggle} />
      </Dialog>
      {/*<Dialog
        title="Login"
        iconName="log-in"
        isCloseButtonShown={false}
        canEscapeKeyClose={false}
        isOpen={props.loginToggle.value}
        onClose={props.loginToggle.toggle}
      >
        <div className="pa2">
          <Form
            form={props.userLoginStore.forms[0]}
            withoutLabels
            large
            submitButton={
              <Button
                onClick={e => {
                  e.preventDefault();
                  if (props.userLoginStore.instance.userName === 'admin' &&
                    props.userLoginStore.instance.password === 'bamos') {
                    props.store!.setAuthenticated();
                    props.store!.app.view.currentView.changeView('admin');
                    props.loginToggle.toggle();
                  } else {
                    props.userLoginStore.forms[0].invalidate('Invalid Credentials');
                  }
                }}
                type="submit"
                className="pt-large pt-intent-primary"
              >Login
              </Button>}
          />
        </div>
      </Dialog>*/}
    </nav>
  </div>
  )));

export const SectionManager = inject('store')(observer((props: { store?: typeof Store.Type }) => {
  if (props.store === null || props.store === undefined) {
    throw Error('INTERNAL ERROR: store has not been injected');
  }
  const view = props.store.app.view;
  const viewName = view.currentView.currentRoute.name;
  let el;
  if (viewName === 'landing') {
    el = <LandingPage />;
  } else if (viewName === 'preConference') {
    el = <PreConference />;
  } else if (viewName === 'cancellationOrRefund') {
    el = <CancellationOrRefund />;
  } else if (viewName === 'venue') {
    el = <Venue />;
  } else if (viewName === 'postConferenceTour') {
    el = <PostConferenceTour />;
  } else if (viewName === 'accommodation') {
    el = <Accommodation />;
  } else if (viewName === 'contactUs') {
    el = <ContactUs />;
  } else if (viewName === 'admin') {
    el = props.store.authenticated ? <AdminPage /> : <LandingPage />;
  }else if (viewName === 'eventpaymentpage') {
    el = <EventPaymentPage />;
  }else if (viewName === 'sponsor') {
    el = <Sponsor />;
  }else if (viewName === 'eventsWorkshop') {
    el = <EventsWorkshop />;
  }
  const loginToggle = ToggleModel.create();
  const registrationToggle = ToggleModel.create();
  const userLoginStore = EntityModel(UserLogin).create();
  userLoginStore.setInstance(UserLogin.create());
  return (
    <div className="cover bg-left bg-center-l vh-100">
      <header className="sans-serif">
        <Navbar
          loginToggle={loginToggle}
          userLoginStore={userLoginStore}
          registrationToggle={registrationToggle}
          viewName={viewName}
        />
      </header>
      {el}
    </div>
  );
})); 


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/SectionManager.tsx